import React from 'react'
import classnames from 'classnames'

export const Button = (props) => {
  const { groupClass, id, disabled, submitting, success, tabindex } = props

  return (
    <div className={classnames('form__group', groupClass)}>
      <button id={id} disabled={disabled} tabIndex={tabindex} className={classnames('button--preloader button--lg icon-font-before icon-check-solid-before', { 'button--active' : !disabled, 'button--loading' : submitting, 'button--success' : success })}>
        <div className="button__text">Submit</div>
        <div className={classnames('button__ripple', { 'button__ripple--active' : success })}></div>
        <div className="preloader-container">
            <div className="preloader preloader--lg preloader--active">
                <div className="preloader__spinner">
                  <div className="preloader__clipper preloader__clipper--left">
                    <div className="preloader__circle"></div>
                  </div>
                  <div className="preloader__gap-patch">
                    <div className="preloader__circle"></div>
                  </div>
                  <div className="preloader__clipper preloader__clipper--right">
                    <div className="preloader__circle"></div>
                  </div>
                </div>
            </div>
        </div>
      </button>
    </div>
  )
}

export default Button



// WEBPACK FOOTER //
// ../app/components/common/Button.jsx